var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#2C2C2C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.906,
    y: 17.8141,
    width: 17.9436,
    height: 15.3177,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0832,
    y: 13,
    width: 21.2041,
    height: 4.98919,
    rx: 2.28,
    fill: "#808080"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1555,
    y: 33.1318,
    width: 21.0071,
    height: 1.75059,
    rx: 0.875296,
    fill: "#808080"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.0918,
    y: 19.16,
    width: 2.62589,
    height: 2.62589,
    rx: 0.5,
    fill: "#808080"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8259,
    y: 19.16,
    width: 2.62589,
    height: 2.62589,
    rx: 0.5,
    fill: "#808080"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.56,
    y: 19.16,
    width: 2.62589,
    height: 2.62589,
    rx: 0.5,
    fill: "#808080"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.56,
    y: 23.5459,
    width: 2.62589,
    height: 2.62589,
    rx: 0.5,
    fill: "#808080"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31.0918,
    y: 23.5459,
    width: 2.62589,
    height: 2.62589,
    rx: 0.5,
    fill: "#808080"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8259,
    y: 23.5459,
    width: 2.62589,
    height: 2.62589,
    rx: 0.5,
    fill: "#808080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0637 29.5015C25.0637 28.606 25.7896 27.88 26.6852 27.88C27.5807 27.88 28.3067 28.606 28.3067 29.5015V33.1186H25.0637V29.5015Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8926 34.9162C15.049 34.972 15.2054 35 15.3618 35C15.5182 35 15.6745 34.972 15.8309 34.9162C15.9873 34.8603 16.1269 34.7766 16.2498 34.6649C16.9759 33.9946 17.6182 33.3412 18.1767 32.7045C18.7352 32.0677 19.2016 31.4506 19.5758 30.853C19.95 30.2554 20.2348 29.6801 20.4303 29.1272C20.6258 28.5742 20.7235 28.0464 20.7235 27.5438C20.7235 25.8682 20.1846 24.5333 19.1066 23.5392C18.0287 22.545 16.7804 22.0479 15.3618 22.0479C13.9431 22.0479 12.6948 22.545 11.6169 23.5392C10.539 24.5333 10 25.8682 10 27.5438C10 28.0464 10.0977 28.5742 10.2932 29.1272C10.4887 29.6801 10.7735 30.2554 11.1478 30.853C11.522 31.4506 11.9883 32.0677 12.5468 32.7045C13.1054 33.3412 13.7477 33.9946 14.4737 34.6649C14.5966 34.7766 14.7362 34.8603 14.8926 34.9162Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0231 33.1958C15.1408 33.2378 15.2585 33.2589 15.3762 33.2589C15.4939 33.2589 15.6116 33.2378 15.7293 33.1958C15.847 33.1538 15.9521 33.0907 16.0446 33.0066C16.5911 32.5022 17.0745 32.0103 17.4949 31.5311C17.9153 31.0519 18.2663 30.5873 18.548 30.1375C18.8296 29.6877 19.044 29.2547 19.1912 28.8385C19.3383 28.4224 19.4119 28.0251 19.4119 27.6468C19.4119 26.3856 19.0062 25.3809 18.1949 24.6326C17.3835 23.8843 16.444 23.5102 15.3762 23.5102C14.3084 23.5102 13.3689 23.8843 12.5575 24.6326C11.7462 25.3809 11.3405 26.3856 11.3405 27.6468C11.3405 28.0251 11.4141 28.4224 11.5612 28.8385C11.7084 29.2547 11.9228 29.6877 12.2044 30.1375C12.4861 30.5873 12.8371 31.0519 13.2575 31.5311C13.6779 32.0103 14.1613 32.5022 14.7078 33.0066C14.8003 33.0907 14.9054 33.1538 15.0231 33.1958Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2801,
    cy: 27.08,
    r: 1.76,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2801,
    cy: 27.08,
    r: 1.76,
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotIcon);
export default __webpack_public_path__ + "static/media/motIcon.392526af4e64137b41cad9f9fa22da1a.svg";
export { ForwardRef as ReactComponent };